import { fork, put, select, take, call } from 'redux-saga/effects';

import { selectUserFeatureFlags } from 'yeself-client-common/security/SecuritySelector';

import { AUTH_SET_USER_PROFILE } from 'yeself-client-common/security/types';

import log from 'yeself-client-common/utils/LogUtils';
import { respawn, watcherActionErrorMessage } from 'yeself-client-common/utils/SagaUtils';

import { featureFlagsSetFlags } from './FeatureFlagsAction';

import { featureFlagsFromGlobalConfig } from './FeatureFlagsService';

export function* authUserProfileTask() {
    const globalFeatureFlags = yield call(featureFlagsFromGlobalConfig);
    const organisationFeatureFlags = yield select(selectUserFeatureFlags);

    yield put(featureFlagsSetFlags({...globalFeatureFlags, ...organisationFeatureFlags}));
}

function* authUserProfileWatcher() {
    try {
        while (true) {
            yield take(AUTH_SET_USER_PROFILE);
            yield fork(authUserProfileTask);
        }
    } catch (err) {
        log.error(err, watcherActionErrorMessage('authSetUserProfileWatcher', [AUTH_SET_USER_PROFILE]));
    }
}

function* FeatureFlagsSaga() {
    yield respawn(authUserProfileWatcher);
}

export default FeatureFlagsSaga;
